import { CommonService } from './../../services/common.service';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { Subject, Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { NewsletterService } from '../../services/newsletter.service';
import { CatalogueModel, CatalogueV2Model, CategorisedNewsletters, NewsLetterV2, SubscribedCategory } from '../../models/catalogue-view.model';
import { FileService } from '../../services/file.service';
import { NgModel } from '@angular/forms';
import { SharedSingleSelectionPipe } from '../../shared/single-selection.pipe';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { NgProgressService } from '../../services/ngProgress.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Sort } from '@angular/material/sort';
import { MatAccordion, MatExpansionPanel } from '@angular/material/expansion';


const LARGETOPWIDTH = "620%";
const UNSETTOPWIDTH = null;
@Component({
  selector: 'app-catalogue-list-v2',
  templateUrl: './catalogue-list-v2.component.html',
  styleUrls: ['./catalogue-list-v2.component.css']
})
export class CatalogueListV2Component implements OnInit {

  title = 'Catalogues';

  accountId: string;
  Catalogue: CatalogueV2Model;
  newsLetters: NewsLetterV2[];
  sortedData: NewsLetterV2[];
  categorisedData: CategorisedNewsletters[];
  subscribedCategories: SubscribedCategory[];
  cataloguecollection$: Subscription;
  closesub$: Subscription;
  selectedBrands = [];
  selectedBrandData = []
  catalogueFilterValue = '';

  allBrandsItem: any[];
  uniqueBrands: string[];
  fixedUniqueBrands: string[];

  url: string;
  newsletterMsg: string;
  closeResult: string;
  switchMsg = 'Edit';

  iconCanbeActive = false;
  hasAutoDeselected = false;
  hasEmptyResult = false;
  hasFilterChanged = false;
  loadContent = false;
  finishDownLoading = true;

  filterResultArr = undefined;

  toplevelWidth = LARGETOPWIDTH;
  selectedFilter = 'categories';
  filteredData: any;
  allCategorySelected: boolean = true;
  allBrandSelected: boolean = true;
  selectedCategoryData: any;
  brandsData: any = [];
  tempBrandsData: any = [];
  toggleData = false
  currentUserModel: CurrentUserModel;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  rotateImage: number = 0;
  selectedItem: string = "categories";
  selectedCategory: any = [];

  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild('popover', { static: true }) public popover: NgbPopover;
  @ViewChild('allSelected', { static: true }) private allSelected: MatOption;
  @ViewChild('brandSelect', { static: true }) private brandSelect: NgModel;
  @ViewChild('matSelect', { static: true }) private matSelect: MatSelect;
  @ViewChild(BreadcrumbComponent, { static: true }) breadcrumbRef: BreadcrumbComponent; // reference to the breadcrumb
  @ViewChild('filterInput', { static: true }) private _inputElement: ElementRef;
  @ViewChildren('panels') panels: QueryList<MatExpansionPanel>;

  sortOrderForCategory : any = 'asc';
  constructor(
    private router: Router,
    private newsletterService: NewsletterService,
    private fileService: FileService,
    private authService: AuthService,
    private commonService: CommonService,
    public ngProgress: NgProgressService,

  ) {
    this.commonService.set(NgbPopover.prototype, ['_unregisterListenersFn'], function () { });

    this.toplevelWidth = this.router.url.includes("newsletter") ? LARGETOPWIDTH : UNSETTOPWIDTH;
  }

  ngOnInit() {
    this.loadContent = false;

    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CurrentUserModel) => {

      this.currentUserModel = res;

      this.accountId = this.currentUserModel.accountId;
      if (res.hideSOH) {
        this.router.navigateByUrl('/home');
      }
    },
      (error: any) => {
        console.error(error);
      });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.ngUnsubscribe)).subscribe((res: NavigationEnd) => {
      if (this.router.url === '/catalogues') {
        $('.child-loader').animate({ scrollLeft: -$('#cataloguelist').width() }, 980);
        this.breadcrumbRef.ngAfterViewInit();
      }
      this.toplevelWidth = res.url.includes("newsletter") ? LARGETOPWIDTH : UNSETTOPWIDTH;
    });

    if (this.router.url !== '/catalogues') {
      this.loadContent = false;  // set to true to avoid load two loading screen at the same time
    }
    this.filterResultArr = new SharedSingleSelectionPipe().transform(this.newsLetters, this.catalogueFilterValue, this.selectedBrands, this.allSelected.selected, 'catalogues');
    
    if (this.filterResultArr === []) {
      this.hasEmptyResult = true;
    }

    this.newsletterService.getAllCatalogues().pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: CatalogueV2Model) => {
      this.Catalogue = data;
      this.newsLetters = this.Catalogue.newsLetters;
      this.sortedData = this.Catalogue.newsLetters;
      this.subscribedCategories = this.Catalogue.subscriptions;
      this.categorisedData = this.sortCategorisedData(this.newsLetters).sort((a, b) => {
        const nameA = a.category.category.toUpperCase();
        const nameB = b.category.category.toUpperCase();
        return nameA.localeCompare(nameB);
      });
      this.manageCategorySelection();
      
      this.categorisedData.map((cat) => {
        cat.newsletters.map((news) => {
          this.brandsData.push(news);
          this.tempBrandsData.push(news);
          
        })
      })
     // this.filterSort();
      
      this.selectedCategoryData = this.categorisedData.sort((a, b) => {
        const nameA = a.category.category.toLowerCase();
        const nameB = b.category.category.toLowerCase();
          this.rotateImage = 0;
          return nameA.localeCompare(nameB);
      });

      this.sortOrderForCategory = this.sortOrderForCategory == 'desc';
      this.filterSort();


      this.allBrandsItem = this.newsLetters;
      const brands = this.newsLetters.filter(x => x.published === '0').map(x => x.brand);
      this.uniqueBrands = brands.filter((x, i, a) => x && a.indexOf(x) === i);
      this.fixedUniqueBrands = brands.filter((x, i, a) => x && a.indexOf(x) === i);

      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
   }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }

  onMenuDownload(menu: string) {
    if (menu == "Download Subscribed to Excel") {
      this.sendAllNewslettersFn();
    }
  }

  onChange(event: any) {
    this.panels.forEach(panel => panel.close());
    let categoryData = this.getCookie('selectedCategory');
    let selectCategory = categoryData ? JSON.parse(categoryData) : [];  
    let selectedCategories = [...this.categorisedData];

  if(selectCategory?.length){
    this.selectedCategoryData = selectedCategories.filter((cat: any) => selectCategory.includes(cat.category.id));
    this.allCategorySelected = false;
    }else {
      this.allCategorySelected = true;
      this.selectedCategoryData = selectedCategories;
    }
    if (this.catalogueFilterValue) {

      this.hasFilterChanged = true;

      let filterValueLowercase = this.catalogueFilterValue.toLowerCase();
      this.selectedCategoryData = this.selectedCategoryData.reduce((regex => (r: any, item: any) => {
        if (regex.test(item.category.category)) {
          r.push(item);
        } else {
          const newsletters = item.newsletters.filter(e => regex.test(e.brand) || regex.test(e.description));
          if (newsletters.length) {
            r.push({ ...item, newsletters })
          }
        }
        return r;
      })(new RegExp(filterValueLowercase, 'i')), []);

      this.accordion.openAll();
      this.toggleData = true;
      this.selectedBrandData = this.brandsData.filter((item) => {
        const brandName = item.brand.toLowerCase().includes(filterValueLowercase);
        const brandDescripion = item.description.toLowerCase().includes(filterValueLowercase);
        return brandName || brandDescripion;
      });

    } else {

      this.hasFilterChanged = false;
      this.selectedBrandData = this.brandsData.sort((a, b) => {
        const nameA = a.brand.toLowerCase() || a.description.toLowerCase();
        const nameB = b.brand.toLowerCase() || b.description.toLowerCase();
        return nameA.localeCompare(nameB);
      })

      // previous code start //
      // this.selectedCategoryData = this.sortCategorisedData(this.newsLetters);
      // previous code end //


      // new code start // 
      this.sortOrderForCategory = this.sortOrderForCategory == 'desc';
      this.filterSort();
      // new code end // 


    }
  }

  dateFormat(item: NewsLetterV2) {
    const date = item.mdate.slice(8, 10);
    const month = item.mdate.slice(5, 7);
    const year = item.mdate.slice(0, 4);
    const newDateFormat = `${date}/${month}/${year}`;
    return newDateFormat;
  }

  openedChange(opened: boolean) {
    if (!opened) {
      if (this.allSelected.selected) {
        this.brandSelect.update.emit([]);
      }
    }
  }

  openPop(): void {
    this.popover.isOpen() ? this.popover.close() : this.popover.open();
    this.popover.isOpen() ? this.iconCanbeActive = true : this.iconCanbeActive = false;
  }

  filterReset(): void {
    this.catalogueFilterValue = '';
    this.hasEmptyResult = false;
    if (!this.uniqueBrands.includes('all')) {
      this.uniqueBrands.push('all');
    }
    this.brandSelect.update.emit([]);
    this._inputElement.nativeElement.focus();
    this.categorisedData = this.sortCategorisedData(this.newsLetters);
  }

  filterSort(): void {
    let sortOrder: 'asc' | 'desc' = 'asc';
    if (this.categorisedData.length > 1 && this.categorisedData[0].category.category < this.categorisedData[1].category.category) {
      sortOrder = 'desc';
    }
    let sortOrderBrands: 'asc' | 'desc' = 'asc'
    if (this.brandsData.length > 1 && this.brandsData[0].brand < this.brandsData[1].brand) {
      sortOrderBrands = 'desc';
    }
    if (this.selectedItem === 'categories') {

      // previous code start //

      // this.selectedCategoryData = this.categorisedData.sort((a, b) => {
      //   const nameA = a.category.category.toLowerCase();
      //   const nameB = b.category.category.toLowerCase();
      //   if (sortOrder === 'asc') {
      //     this.rotateImage = 0;
      //     return nameA.localeCompare(nameB);
      //   } else {
      //     this.rotateImage = 1;
      //     return nameB.localeCompare(nameA);
      //   }
      // });

      // previous code end //


      // new code start //

      this.sortOrderForCategory = (this.sortOrderForCategory == 'asc') ? 'desc' : 'asc';
      
      let subscribedData =  this.categorisedData.filter(
        x => this.subscribedCategories.findIndex(y => y.category == x.category.id && y.isActive === true) > -1);
      let arrayTobeSorted = this.categorisedData.filter(
        x => this.subscribedCategories.findIndex(y => y.category == x.category.id && y.isActive === true) === -1);

       let sortedArray = arrayTobeSorted.sort((a, b) => {
          const nameA = a.category['category'].toLowerCase();
          const nameB = b.category['category'].toLowerCase();
          if (this.sortOrderForCategory === 'asc') {
            this.rotateImage = 0;
            return nameA.localeCompare(nameB);
          } else {
            this.rotateImage = 1;
            return nameB.localeCompare(nameA);
          }
        });

        this.selectedCategoryData = [...subscribedData,...sortedArray];

       // new code end //

    } else {
      this.selectedBrandData = this.brandsData.sort((a, b) => {
        const nameA = a.brand.toUpperCase();
        const nameB = b.brand.toUpperCase();
        if (sortOrderBrands === 'asc') {
          this.rotateImage = 0;
          return nameA.localeCompare(nameB);
        } else {
          this.rotateImage = 1;
          return nameB.localeCompare(nameA);
        }
      });
    }
  }
  popOpen(p: NgbPopover): void {
    p.open();
  }
  closeDownload(): void {
    this.popover.close();
    this.iconCanbeActive = false;
  }
  toggleAllSelection(selectedBrands: NgModel) {
    if (this.selectedBrands.length === this.uniqueBrands.length - 1) {
      selectedBrands.update.emit([]);
    } else if (this.hasAutoDeselected && !this.allSelected.selected) {
      if (!this.uniqueBrands.includes('all')) {
        this.uniqueBrands.push('all');
      }
      selectedBrands.update.emit(this.uniqueBrands);
    } else if (this.selectedBrands.length === this.uniqueBrands.length && this.selectedBrands.length > 0 && this.allSelected.selected) {
      selectedBrands.update.emit([]);
    } else if (this.allSelected.selected) {
      if (!this.uniqueBrands.includes('all')) {
        this.uniqueBrands.push('all');
      }
      selectedBrands.update.emit(this.uniqueBrands);
    }
  }

  tickAllOptionsByOpeningPanel(event) {
    if ($(event.target).closest('.mat-input-flex.mat-form-field-flex').length) {
      if (!this.uniqueBrands.includes('all')) {
        this.uniqueBrands.push('all');
      }
      if (this.selectedBrands.length === 0) {
        this.brandSelect.update.emit(this.uniqueBrands);

      }
    }
  }

  onChangeFilter() {
    this.catalogueFilterValue = ''
    if (this.selectedFilter == 'brands') {
      this.rotateImage = 0;
      this.selectedItem = "brands"
      this.allBrandSelected = true;

      this.brandsData = this.tempBrandsData,
        this.selectedBrandData = this.tempBrandsData
      this.filteredData = [{ name: "A", value: "a", disabled: false }, { name: "B", value: "b", disabled: false },
      { name: "C", value: "c", disabled: false }, { name: "D", value: "d", disabled: false },
      { name: "E", value: "e", disabled: false }, { name: "F", value: "f", disabled: false }, { name: "G", value: "g", disabled: false },
      { name: "H", value: "h", disabled: false }, { name: "I", value: "i", disabled: false }, { name: "J", value: "j", disabled: false },
      { name: "K", value: "k", disabled: false }, { name: "L", value: "l", disabled: false }, { name: "M", value: "m", disabled: false },
      { name: "N", value: "n", disabled: false }, { name: "O", value: "o", disabled: false }, { name: "P", value: "p", disabled: false },
      { name: "Q", value: "q", disabled: false }, { name: "R", value: "r", disabled: false }, { name: "S", value: "s", disabled: false },
      { name: "T", value: "t", disabled: false }, { name: "U", value: "u", disabled: false }, { name: "V", value: "v", disabled: false },
      { name: "W", value: "w", disabled: false }, { name: "X", value: "x", disabled: false }, { name: "Y", value: "y", disabled: false },
      { name: "Z", value: "z", disabled: false },
      ];
      let temp = this.fixedUniqueBrands?.map((brandName: any) => {
        return brandName.charAt(0);
      })
      this.filteredData.map((capital: any) => {
        if (temp?.includes(capital.name)) {
        } else {
          capital.disabled = true;
        }
      })

      this.brandsData.sort((a, b) => {
        const nameA = a.brand.toUpperCase();
        const nameB = b.brand.toUpperCase();
        return nameA.localeCompare(nameB)

      });
    }
    else {
      this.rotateImage = 0;
      this.selectedItem = "categories"
      this.categorisedData.sort((a, b) => {
        const nameA = a.category.category.toUpperCase();
        const nameB = b.category.category.toUpperCase();
        return nameA.localeCompare(nameB);
      })
      this.manageCategorySelection();
    }
  }

  manageCategorySelection() {
    let categoryData = this.getCookie('selectedCategory');
    let selectCategory = categoryData ? JSON.parse(categoryData) : [];
    this.categorisedData.forEach((cat) => {
      if (categoryData?.length) {
        let found = false;

        selectCategory.forEach(element => {
          if (element === cat?.category?.id) {
            found = true;
          }
        });
        
        cat.category.selected = found;
        this.allCategorySelected = false;
      }
      else {
        cat.category.selected = false;
        this.allCategorySelected = true;
      }
    })
    
    if(selectCategory?.length){
      this.selectedCategoryData = this.categorisedData.filter((cat: any) => selectCategory.includes(cat.category.id));
      this.allCategorySelected = false;
      }else {
        this.allCategorySelected = true;
        this.selectedCategoryData = this.categorisedData;
      }
      this.selectedCategoryData = this.sortCategorisedData(this.newsLetters);
  }

  onChangeAll() {
    this.deleteCookie("selectedCategory");
    if (this.selectedFilter == 'categories') {
      this.allCategorySelected = true;
      this.categorisedData.map((cat) => {
        cat.category.selected = false;
      })
      this.selectedCategoryData = this.categorisedData;

      this.sortOrderForCategory = this.sortOrderForCategory == 'desc';
      this.filterSort();
    } else {
      this.allBrandSelected = true;
      this.filteredData.map((filtered) => {
        filtered.selected = false;
      })
      this.brandsData = this.tempBrandsData
      this.selectedBrandData = this.tempBrandsData
    }
  }

  onChangeBrand(type, data) {
    if (type == 'brand') {
      this.filteredData.map((filtered) => {
        if (filtered.name == data.name) {
          filtered.selected = true;
        } else {
          filtered.selected = false;
        }
      })
      this.brandsData = []
      this.selectedBrandData = []
      this.tempBrandsData.map((brand: any) => {
        if (brand?.brand?.charAt(0) == data.name) {
          this.brandsData.push(brand);
          this.selectedBrandData.push(brand)
        }
      })
      this.allBrandSelected = false;
    } else {
      this.allBrandSelected = true;
      this.filteredData.map((filtered) => {
        filtered.selected = false;
      })
    }

  }

  onChangeCategory(type, data) {
    if (type == 'category') {
      let categoryData = this.getCookie('selectedCategory');
      this.selectedCategory = categoryData ? JSON.parse(categoryData) : [];
      let categoryId = data.category.id;
      const index = this.selectedCategory.indexOf(categoryId);
      if (index === -1) {
        this.selectedCategory.push(categoryId);
      } else {
        this.selectedCategory.splice(index, 1);
      }
      let myArrayValue = JSON.stringify(this.selectedCategory);
      this.setCookie('selectedCategory', myArrayValue, 365);
      this.categorisedData.forEach((cat) => {
        if (this.selectedCategory && this.selectedCategory.length) {
            let found = false;
            this.selectedCategory.forEach(element => {
              if (element === cat?.category?.id) {
                found = true;
              }
            });
            cat.category.selected = found;
            this.allCategorySelected = false;    
        }
        else {
          cat.category.selected = false;
          this.allCategorySelected = true;
        }
      })
      if(this.selectedCategory?.length){
        this.selectedCategoryData = this.categorisedData.filter((cat: any) => this.selectedCategory.includes(cat.category.id));
        this.allCategorySelected = false;
        }else {
          this.allCategorySelected = true;
          this.selectedCategoryData = this.categorisedData;
        }
    } else {
      this.deleteCookie("selectedCategory");
      this.allCategorySelected = true;
      this.categorisedData.map((cat) => {
        cat.category.selected = false;
      })
      this.selectedCategoryData = this.categorisedData;
    }
  }

  getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=');
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  setCookie(name, value, daysToExpire) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + daysToExpire);
    const cookieString = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
    document.cookie = cookieString;
  }

  deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }

  updateBrandList(brandSelect: NgModel) {
    if ((this.selectedBrands.length < this.uniqueBrands.length) && this.allSelected.selected && this.selectedBrands.length !== 1) {
      this.allSelected.deselect();
      this.hasAutoDeselected = true;
    }
    if ((this.selectedBrands.length === (this.uniqueBrands.length - 1)) && !this.selectedBrands.includes('all')) {
      this.allSelected.select();
    }
  }

  exportExcelForCatalogue(newsId: string): void {

    this.finishDownLoading = false;

    this.newsletterService.exportExcelForCatalogueSQL(newsId).subscribe((data: any) => {
      const fileName = 'Dicker Data - ' + this.newsLetters.find(x => x.news_id == newsId).title;

      this.fileService.saveAsExcelFile(data, fileName);
      this.finishDownLoading = true;

    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  sendAllNewsletters(billTo: string, content: any, event: any): void {
    this.finishDownLoading = false;

    event.preventDefault();
    event.stopPropagation();
    this.sendAllNewslettersFn();

  }

  sendAllNewslettersFn() {
    this.newsletterService.sendAllNewsletters(this.accountId).subscribe((res: any) => {
      this.newsletterMsg = '';
      if (res.status) {
        if (res.responseMessage === 'added') {
          this.commonService.implementToast('The latest copy of the Dicker Data pricelist is being generated and emailed to you. It may take up to 15 minutes for you to receive this email', 'Success');
        } else if (res.responseMessage === 'queue') {
          this.commonService.implementToast('Your copy of the Dicker Data pricelist is in email queue. It may take up to 15 minutes for you to receive this email.', 'Success');
        } else if (res.responseMessage === 'noemail') {
          this.commonService.implementToast('Please update your email in the profile section and try again.', 'Error');

        } else if (res.responseMessage === 'noaccount') {
          this.commonService.implementToast('Not a valid account.', 'Error');
        }


        if (this.popover.isOpen()) {
          $('#downloadButton').click();
          this.finishDownLoading = true;
        }
      }
    },
      (error: any) => {
        console.error(error);
        this.finishDownLoading = true;
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  goToNewsletterView(newsId: string): void {

    if (this.breadcrumbRef) {
      this.breadcrumbRef.ngAfterViewInit();
    }
  }

  switchCatalogueMode(): void {
    this.router.navigateByUrl('/catalogueedit');
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {

    if (this.router.url === '/catalogues') {
      this.router.navigateByUrl('/home');
    } else {
      this.router.navigateByUrl('/catalogues');
    }
  }

  sortData(sort: Sort) {
    const data = this.newsLetters.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'brand': return compare(a.brand, b.brand, isAsc);
        case 'description': return compare(a.description, b.description, isAsc);
        default: return 0;
      }
    });
  }

  sortCategorisedData(source: NewsLetterV2[]): CategorisedNewsletters[] {
    let data: CategorisedNewsletters[] = [];
    let subscribedCategories = this.Catalogue.categories.filter(
      x => this.subscribedCategories.findIndex(y => y.category == x.id && y.isActive === true) > -1);
    let otherCategories = this.Catalogue.categories.filter(
      x => this.subscribedCategories.findIndex(y => y.category == x.id && y.isActive === true) === -1);

    let uncategorised = source.filter(x => !x.category && x.published == '0');
    let otherCatDetail = null;
    if (uncategorised.length > 0) {
      otherCatDetail = {
        category: { id: '-1', category: 'OTHER', description: '', selected: false },
        newsletters: uncategorised
      };
      let res = this.subscribedCategories?.find(category => category?.category == otherCatDetail?.category?.id);
      otherCatDetail['isActive'] = (res?.isActive == true) ? res?.isActive : false;
    }

      
    for (var i = 0; i < subscribedCategories.length; i++) {
      data.push({
        category: subscribedCategories[i],
        newsletters: source.filter(x => x.category == subscribedCategories[i].id && x.published == '0')
      });
    }

    if(otherCatDetail && otherCatDetail['isActive'] == true)
    {
      delete  otherCatDetail['isActive'];
      data.push(otherCatDetail);
      otherCatDetail = null;
    }

    for (var i = 0; i < otherCategories.length; i++) {
      data.push({
        category: otherCategories[i],
        newsletters: source.filter(x => x.category == otherCategories[i].id && x.published == '0')
      });
    }

    if(otherCatDetail && otherCatDetail['isActive'] == false)
    {
      delete  otherCatDetail['isActive'];
      data.push(otherCatDetail);
      otherCatDetail = null;
    }

    return data;
  }

  saveSubscription(category: string, event) {
    event.stopPropagation();
    var idx = this.subscribedCategories.findIndex(x => x.category == category);
    if (idx > -1) {
      this.subscribedCategories[idx].isActive = !this.subscribedCategories[idx].isActive;
      this.newsletterService.saveCategoryForUser(this.subscribedCategories[idx]).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: SubscribedCategory) => {
        if (this.subscribedCategories[idx].isActive == true) {
          this.commonService.implementToast('Category favourited!', 'Success', false);
        } else {
          this.commonService.implementToast('Category unfavourited!', 'Success', false);
        }
        this.loadContent = false;
        // this.categorisedData = this.sortCategorisedData(this.newsLetters);
        // this.selectedCategoryData = this.categorisedData;
        let data = this.sortCategorisedData(this.newsLetters);
        this.selectedCategoryData = data;
        
        this.loadContent = true;
      },
        (error: any) => {
          console.error(error);
        });
    } else {
      var newSub = {
        id: '-1',
        category: category,
        isActive: true
      };
      this.subscribedCategories.push(newSub);
      this.newsletterService.saveCategoryForUser(newSub).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: SubscribedCategory) => {
        var newIdx = this.subscribedCategories.findIndex(x => x.category == res.category);
        this.subscribedCategories[newIdx].id = res.id;
        if (this.subscribedCategories[newIdx].isActive == true) {
          this.commonService.implementToast('Category favourited!', 'Success', false);
        }

        this.loadContent = false;
        this.categorisedData = this.sortCategorisedData(this.newsLetters);
        this.loadContent = true;

      },
        (error: any) => {
          console.error(error);
        });
    }
  }

  applySubscription(category: string): boolean {
    var checked = false;
    var idx = this.subscribedCategories.findIndex(x => x.category);
    if (idx > -1) {
      checked = this.subscribedCategories[idx].isActive;
    }
    return checked;
  }

  accordianExpanded(categoryId: string): boolean {
    var expanded = false;
    if (!this.subscribedCategories) {
      expanded = true;
    }
    if (this.subscribedCategories.length == 0) {
      expanded = true;
    }
    if (this.subscribedCategories.findIndex(x => x.category === categoryId && x.isActive == true) > -1) {
      expanded = true;
    }
    return expanded;

  }

  isSubscribed(categoryId: string): boolean {
    return this.subscribedCategories.findIndex(x => x.category === categoryId && x.isActive == true) > -1;
  }

  migrateFromPostgres() {
    this.newsletterService.migrateNewsletters().subscribe((res: any) => {
      if (res.status) {
        this.commonService.implementToast(res.responseMessage, 'Success');
      } else {
        this.commonService.implementToast(res.responseMessage, 'Error');
      }
    },
      (error: any) => {
        console.error(error);
        this.finishDownLoading = true;
      });
  }

  clearSQLDB() {
    this.newsletterService.clearNewsletters().subscribe((res: any) => {
      if (res.status) {
        this.commonService.implementToast(res.responseMessage, 'Success');
      } else {
        this.commonService.implementToast(res.responseMessage, 'Error');
      }
    },
      (error: any) => {
        console.error(error);
        this.finishDownLoading = true;
      });
  }

  get isDev() {
    return this.commonService.getIsDevOps();
  }

}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
